import { getSemanticColorVariable } from 'app/components/v2/theme/colors';

import { BorderWidth } from '../components/Box';

export type BorderRadius = 'lg' | 'md' | 'sm' | 'xs';

export type Spacing = 'auto' | 'lg' | 'md' | 'none' | 'sm' | 'xl' | 'xs' | 'xxl' | 'xxxl' | 'xxxxl' | 'xxxxxl';

export const overlay = '#00000099';

const opacity = {
  modal: 0.75,
};

const backgrounds = {
  clearBlack: 'rgba(0, 0, 0, 0)',
  clearWhite: 'rgba(255, 255, 255, 0)',
  modal: `rgba(0, 0, 0, ${opacity.modal})`,
};

const boxShadow = {
  default: `0px 2px 6px ${getSemanticColorVariable('box_shadow')}`,
};

const borderRadius: Record<BorderRadius, number> = {
  lg: 16,
  md: 8,
  sm: 4,
  xs: 2,
};

const borderWidths: Record<string, BorderWidth> = {
  default: 2,
  toggle: 2,
};

export const breakPoints = {
  desktop: 1199,
  mobile: 767,
  tablet: 991,
  xs: 480,
};

const paddingNumbers: Record<Spacing, number> = {
  auto: 0,
  lg: 24,
  md: 16,
  none: 0,
  sm: 8,
  xl: 32,
  xs: 4,
  xxl: 40,
  xxxl: 48,
  xxxxl: 60,
  xxxxxl: 72,
};

const padding: Record<Spacing, string> = {
  auto: 'auto',
  lg: `${paddingNumbers.lg}px`,
  md: `${paddingNumbers.md}px`,
  none: `${paddingNumbers.none}px`,
  sm: `${paddingNumbers.sm}px`,
  xl: `${paddingNumbers.xl}px`,
  xs: `${paddingNumbers.xs}px`,
  xxl: `${paddingNumbers.xxl}px`,
  xxxl: `${paddingNumbers.xxxl}px`,
  xxxxl: `${paddingNumbers.xxxxl}px`,
  xxxxxl: `${paddingNumbers.xxxxxl}px`,
};

const zIndex = {
  drawer: 100,
  modal: 150,
  nav: 5,
  notification: 200,
  overlay: 10,
};

const styles = {
  backgrounds,
  borderRadius,
  borderWidths,
  boxShadow,
  breakPoints,
  padding,
  paddingNumbers,
  zIndex,
};

export default styles;
